import config from "../config";
import { createPortal } from "react-dom";

function isLocalStorageNameSupported() {
  const testKey = "test";
  const storage = window.localStorage;
  try {
    storage.setItem(testKey, "1");
    storage.getItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}

export function getTermsUrl(url) {
  return url.replace(/^.*\/\/[^\/]+/, ""); // eslint-disable-line no-useless-escape
}

export function getViewportDimensions() {
  const height = window.innerHeight || "";
  const width = window.innerWidth || "";
  return typeof width === "number" && typeof height === "number"
    ? `${width}:${height}`
    : "";
}

export function getCountryFromLocalStorage() {
  const country = window.asos.webContext.getBrowseCountry();
  if (isLocalStorageNameSupported()) {
    return window.localStorage.getItem("premierCountry") || country;
  }

  return country;
}

export function isPremierAvailable(code, countries) {
  return (
    countries &&
    countries.filter(
      (country) => country.country && country.country.code === code
    ).length
  );
}

export function getCountryEndpoint(
  country,
  currency,
  language,
  showTrialOffers = false
) {
  return addXSiteOrigin(
    `${config.subscriptionsEndpoint}?country=${country}&currency=${currency}&lang=${language}&showTrialOffers=${showTrialOffers}`
  );
}

export function sortAlphabetically(countries) {
  const collator = new Intl.Collator();

  if (collator) {
    return countries.sort((a, b) =>
      collator.compare(a.country.name, b.country.name)
    );
  }

  return countries.sort((a, b) => {
    if (a.country.name < b.country.name) return -1;
    else if (a.country.name > b.country.name) return 1;
    return 0;
  });
}

export function sortBySelectedCountry(countryCode, countries) {
  const countryIndex = countries.findIndex(
    (item) => item.country.code === countryCode
  );
  if (countryIndex === 0) {
    return countries;
  }

  const country = countries.splice(countryIndex, 1);
  countries.unshift(country && country[0]);
  return countries;
}

export function trapFocus(container) {
  if (!container) return;
  const iframeEl =
    container.querySelector("iframe") &&
    container.querySelector("iframe").contentWindow;
  const elementArray = [
    ...container.querySelectorAll("button, [href], iframe"),
  ];
  const focusLimit = { first: 0, last: elementArray.length - 1 };
  let index = 0;
  elementArray[index].focus();

  [container, iframeEl].forEach(
    (el) =>
      el &&
      el.addEventListener("keydown", (event) => {
        if (!(event.key === "Tab")) return;
        index += event.shiftKey ? -1 : 1;

        if (index < focusLimit.first) index = focusLimit.last;
        if (index > focusLimit.last) index = focusLimit.first;

        event.preventDefault();
        elementArray[index].focus();
      })
  );
}

export const Portal = ({ children }) => {
  const modalContainer = document.getElementById("chrome-modal-container");
  return createPortal(children, modalContainer);
};

const setAriaHidden = (content, hidden) => {
  if (hidden) {
    content.setAttribute("aria-hidden", true);
  } else {
    content.removeAttribute("aria-hidden");
  }
};

export function toggleBodyClass(modalVisible) {
  const htmlClass = document.documentElement.className;
  const bodyClass = document.body.className;
  const modalContainer = document.getElementById("chrome-modal-container");

  setAriaHidden(modalContainer, !modalVisible);
  const mainContent = document.getElementsByClassName(
    "chrome-main-content--accessible"
  );

  for (const content of mainContent) {
    setAriaHidden(content, modalVisible);
  }

  if (modalVisible) {
    document.body.className += " scrollHidden";
    document.documentElement.className += " scrollHidden";
  } else {
    document.body.className = bodyClass.replace(" scrollHidden", "");
    document.documentElement.className = htmlClass.replace(" scrollHidden", "");
  }
}

export function addXSiteOrigin(url) {
  const params = new URLSearchParams(window.location.search);
  const xSiteOrigin = params.get("x-site-origin");
  return xSiteOrigin ? `${url}&x-site-origin=${xSiteOrigin}` : url;
}
